<template>
    <div class="filip_section flip-object-toolbar">
        <div class="layer_parent_div">
            <button
                type="button"
                @click="setValue('left')"
                :class="btnClass(true, flipX)"
            >
                <img src="./icon/flip-1.png" />
            </button>
            <button
                type="button"
                @click="setValue('top')"
                :class="btnClass(false, flipY)"
            >
                <img src="./icon/flip-2.png" />
            </button>
        </div>
        <label>Flip</label>
    </div>
</template>

<script>
export default {
    /* eslint-disable */
    name: "Flip",
    /* eslint-enable */
    props: {
        flipX: { type: Boolean, default: false },
        flipY: { type: Boolean, default: false }
    },
    data: () => {
        return {};
    },
    methods: {
        setValue(e) {
            this.$emit("set-value", e);
        },
        btnClass(isFirst, isOn) {
            const base = isFirst ? "bcommon b1 first" : "bcommon b2 last";
            return isOn ? `${base} active` : base;
        }
    }
};
</script>

<style>
.layer_parent_div {
    display: flex;
    align-items: stretch;
    width: 100%;
    margin: 0px 15px;
}

.bcommon {
    background-color: initial;
    color: #7796a8;
    border: 1px solid;
    border-radius: 0 !important;
    background: #7796a8;
    width: 40px;
}

.b1 {
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;
}

.b2 {
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
}

/*
 * Flip row (Add Text + Edit Clipart): inactive = white, active = #e8e8e8 — same as Center.vue align.
 */
.design_studio_tool
    div#add-text
    .center_layering_filip
    .filip_section.flip-object-toolbar
    button.bcommon:not(.active),
.design_studio_up
    .design_studio_tool
    div#add-text
    .center_layering_filip
    .filip_section.flip-object-toolbar
    button.bcommon:not(.active) {
    background: #ffffff !important;
    border: 1px solid #707070 !important;
}

.design_studio_tool
    div#add-text
    .center_layering_filip
    .filip_section.flip-object-toolbar
    button.bcommon.active,
.design_studio_up
    .design_studio_tool
    div#add-text
    .center_layering_filip
    .filip_section.flip-object-toolbar
    button.bcommon.active {
    background: #e8e8e8 !important;
    border: 1px solid #707070 !important;
}

.design_studio_tool
    .rt-edit-template
    .center_layering_filip
    .filip_section.flip-object-toolbar
    button.bcommon:not(.active),
.design_studio_up
    .design_studio_tool
    .rt-edit-template
    .center_layering_filip
    .filip_section.flip-object-toolbar
    button.bcommon:not(.active) {
    background: #ffffff !important;
    border: 1px solid #707070 !important;
}

.design_studio_tool
    .rt-edit-template
    .center_layering_filip
    .filip_section.flip-object-toolbar
    button.bcommon.active,
.design_studio_up
    .design_studio_tool
    .rt-edit-template
    .center_layering_filip
    .filip_section.flip-object-toolbar
    button.bcommon.active {
    background: #e8e8e8 !important;
    border: 1px solid #707070 !important;
}
.design_studio_up .clipart_panel .flip-object-toolbar{
   margin-left: 7px;
}
.design_studio_up .design_panel_new .flip-object-toolbar{
   margin-left: 10px;
}
</style>
